@if (showFilter) {
<mat-form-field>
	<mat-label>Filter</mat-label>

	<input
		matInput
		[(ngModel)]="value"
		placeholder="Search"
		#input
		(keyup)="applyFilter($event)"
	/>
	@if (value) {
	<button matSuffix mat-icon-button aria-label="Clear" (click)="value = ''">
		<mat-icon>close</mat-icon>
	</button>
	}
</mat-form-field>
}
<div class="table-container" style="overflow: auto; white-space: nowrap">
	<table
		mat-table
		matSort
		(matSortChange)="sortChange($event)"
		aria-describedby="table-component"
		[dataSource]="dataSource"
		class="mat-elevation-z8"
	>
		<!-- Checkbox Column -->
		@if (showSelect) {
		<ng-container matColumnDef="select">
			<th mat-header-cell *matHeaderCellDef class="select-header">
				Select
			</th>
			<td mat-cell *matCellDef="let element">
				<mat-checkbox (change)="selectHandler(element, $event)">
				</mat-checkbox>
			</td>
		</ng-container>
		} @if (moveTable) {
		<ng-container matColumnDef="move">
			<th mat-header-cell *matHeaderCellDef></th>

			<td mat-cell *matCellDef="let element; let i = index">
				<button
					style="max-width: 20px; padding: 0"
					mat-menu-item
					class="order-button"
					(click)="moveRow(i, true)"
					[disabled]="i === 0"
				>
					<mat-icon>keyboard_arrow_up</mat-icon>
				</button>

				<button
					style="max-width: 20px; padding: 0"
					mat-menu-item
					class="order-button"
					(click)="moveRow(i)"
					[disabled]="i === data.length - 1"
				>
					<mat-icon>keyboard_arrow_down</mat-icon>
				</button>
			</td>
		</ng-container>
		} @for (header of headersToDisplay; track header.property) {
		<ng-container [matColumnDef]="header.property ?? ''">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>
				{{ header.description }}
			</th>

			@if (header.clickable) {
			<td mat-cell *matCellDef="let element">
				<button
					mat-raised-button
					(click)="
						onClickCell({
							eventName: header.property,

							element: this.element
						})
					"
				>
					{{
						header.customPipe
							? header.customPipe.transform(
									findProperty(element, header.property ?? '')
							  )
							: findProperty(element, header.property ?? '')
					}}
				</button>
			</td>
			} @else {
			<td mat-cell *matCellDef="let element">
				{{
					header.customPipe
						? header.customPipe.transform(
								findProperty(element, header.property ?? '')
						  )
						: findProperty(element, header.property ?? '')
				}}
			</td>
			}
		</ng-container>
		} @if (showActions) {
		<ng-container matColumnDef="action">
			<th mat-header-cell *matHeaderCellDef>Action</th>

			<td mat-cell *matCellDef="let element">
				<button mat-button [matMenuTriggerFor]="menu">
					<mat-icon>more_vert</mat-icon>
				</button>

				<mat-menu #menu="matMenu">
					@for (action of actions; track action.icon) {
					<button
						mat-menu-item
						(click)="actionClicked(action, element)"
					>
						<mat-icon>{{ action.icon }}</mat-icon>

						<span>{{ action.description }}</span>
					</button>
					}
				</mat-menu>
			</td>
		</ng-container>
		}

		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

		<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>

	<mat-paginator
		[pageSizeOptions]="pageSizeOptions"
		showFirstLastButtons
	></mat-paginator>
</div>
